export function menu(){

  // /** MOBILE MENU */
  $(function() {
    //menu toggle
    $('#menu-toggle').on('click', function(){
      $(this).toggleClass('active');
      $('body').toggleClass("showmenu");
    });

    // mobile menu
    var mobileMenu = $('.mobile-menu .menu');
    mobileMenu.children('li').each(function() {
      if($(this).hasClass('menu-item-has-children')) {
        $(this).prepend('<span class="arrowCtl"><em class="fa fa-chevron-down"></em></span>');
      }
    });
    var aCtrl = $('.arrowCtl');
    aCtrl.on('click', function() {
      var subMenu = $(this).siblings('ul');
      if(subMenu.is(':hidden')) {
        subMenu.slideDown('400');
        $(this).children('em').removeClass('fa fa-chevron-down').addClass('fa fa-chevron-up');
      } else {
        subMenu.slideUp('400');
        $(this).children('em').removeClass('fa fa-chevron-up').addClass('fa fa-chevron-down');
      }
    });
  });


  // /** SLIDER */

  //Handle accordion menu SP  
  // $(function(){
  //   $('body').on('click', '.menu__item', function(){
  //     $(this).find('.submenu').slideToggle("swing");
  //     $(this).find('.ques_expand').toggleClass('active');
  //   });
  // })

  // function clickMenuHeader(){
  //   if ($(window).width() <= 1023) {
  //     $('body').on('click', '.menu__item', function(){
  //       $(this).find('.submenu').stop(true).slideToggle("swing");
  //       $(this).find('.ques_expand').stop(true).toggleClass('active');
  //     });
  //   }
  // }
  // clickMenuHeader();
  
  // function clickMenuFooter(){
  //   if ($(window).width() <= 1023) {
  //     $('body').on('click', '.menufooter__item', function(){
  //       $(this).find('.submenu').stop(true).slideToggle("swing");
  //       $(this).find('.ques_expand').stop(true).toggleClass('active');
  //     });
  //   }
  // }
  // clickMenuFooter();

  // $(window).on('resize' , function() {
  //   if ($(window).width() > 1023) {
  //     $('.sitefooter .footer .submenu').css('display','');
  //     $('body').off('click', '.menufooter__item')
  //     $('body').off('click', '.menu__item')
  //   } else {
  //     // $('.sitefooter .footer .submenu').css('display','none');
  //     $('.sitefooter .footer .menufooter__item .ques_expand').removeClass('active');
  //     clickMenuFooter();
  //     clickMenuHeader();
  //   }
  // });

  $('.mobile-menu .menu__item').click(function () {
    $(this).find('.submenu').slideToggle("swing");
    $(this).find('.ques_expand').toggleClass('active');
  });

  $('.sitefooter .footer .menufooter__item > span').click(function () {
    $(this).parent().find('.submenu').slideToggle("swing");
    $(this).parent().find('.ques_expand').toggleClass('active');
  });

  $(window).on('resize', function () {
    if ($(window).width() > 1023) {
      $('.sitefooter .footer .submenu').css('display', 'block');
    } else {
      $('.sitefooter .footer .submenu').css('display', 'none');
      $('.sitefooter .footer .menufooter__item .ques_expand').removeClass('active');
    }
  });

}